module.exports = __webpack_public_path__ + "assets/img/vision.b3a70071.png";